import React from 'react';
import UseFulFilesPresentational from './useful-files-presentational';

const UseFulFilesFunctional = () => {
	return <UseFulFilesPresentational />;
};
export default UseFulFilesFunctional;
